module.exports = __webpack_public_path__ + "img/company_logo_small_desktop.162a6662.jpg";